module.exports = "<h1 class=\"progress--description\">\n  <span translate=\"{{progress.message}}\"></span>\n</h1>\n<uib-progressbar animate=\"false\"\n                 class=\"progress-striped active\"\n                 type=\"{{progress.type}}\"\n                 value=\"progress.value\"></uib-progressbar>\n<h1 class=\"progress--percentage\">\n  <span>{{progress.value | number: 0}}%</span>\n</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/directives/progressBar/progressBar.html
// module id = 129
// module chunks = 0